import { Loader2 } from 'lucide-react';
import styles from './LoadingState.module.css';

type Props = {
  label?: string;
  hint?: string;
};

export function LoadingState({
  label = 'Generando contenido…',
  hint = 'Esto puede tardar unos segundos'
}: Props) {
  return (
    <div className={styles.wrap}>
      <div className={styles.spinnerBox}>
        <Loader2 size={20} className={styles.spinner} strokeWidth={2.4} />
      </div>
      <div className={styles.texts}>
        <p className={styles.label}>{label}</p>
        <p className={styles.hint}>{hint}</p>
      </div>
      <div className={styles.skeletonGroup}>
        <div className={styles.skeletonLine} style={{ width: '92%' }} />
        <div className={styles.skeletonLine} style={{ width: '78%' }} />
        <div className={styles.skeletonLine} style={{ width: '88%' }} />
        <div className={styles.skeletonLine} style={{ width: '52%' }} />
      </div>
    </div>
  );
}

export function ErrorState({
  error,
  onRetry
}: {
  error: Error | unknown;
  onRetry?: () => void;
}) {
  const message = error instanceof Error ? error.message : 'Algo ha fallado';
  return (
    <div className={styles.wrap}>
      <div className={styles.errorIcon} aria-hidden>!</div>
      <div className={styles.texts}>
        <p className={styles.label}>No se ha podido generar</p>
        <p className={styles.hint}>{message}</p>
      </div>
      {onRetry && (
        <button type="button" className={styles.retry} onClick={onRetry}>
          Reintentar
        </button>
      )}
    </div>
  );
}
